import { createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("AI の利用額の上限を変更")
const _hoisted_2 = { class: "space-y-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-gray-600 mb-1" }, "現在の上限", -1)
const _hoisted_4 = { class: "font-medium" }
const _hoisted_5 = { class: "text-xs text-gray-500" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-gray-600 mb-2" }, " 新しい上限（生徒 1 人あたり・月） ", -1)
const _hoisted_7 = { class: "space-y-2 text-sm" }
const _hoisted_8 = { class: "flex items-center gap-2 h-9" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 既定値（契約区分で決まる） ")
const _hoisted_10 = { class: "flex items-center gap-2 h-9" }
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 金額 ")
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "$", -1)
const _hoisted_14 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_15 = { class: "flex items-center gap-2 h-9" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 上限なし ")
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-gray-600 mb-2" }, "適用開始", -1)
const _hoisted_18 = { class: "space-y-2 text-sm" }
const _hoisted_19 = { class: "flex items-center gap-2 h-9" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" すぐ ")
const _hoisted_21 = { class: "flex items-center gap-2 h-9" }
const _hoisted_22 = { class: "flex items-center gap-2" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 日時を指定 ")
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "text-xs text-gray-500 mt-2" }, " 月の途中から適用しても、その月の 1 日からの利用額で判定します。 ", -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" キャンセル ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 確定 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_area = _resolveComponent("m-text-area")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, {
    size: "sm",
    "is-overlay": true,
    height: "auto",
    onClose: _ctx.close
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _hoisted_3,
          _createVNode("p", _hoisted_4, _toDisplayString(_ctx.currentText), 1),
          _createVNode("p", _hoisted_5, _toDisplayString(_ctx.currentSourceText), 1)
        ]),
        _createVNode("div", null, [
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            _createVNode("label", _hoisted_8, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.kind = $event)),
                type: "radio",
                value: "default"
              }, null, 512), [
                [_vModelRadio, _ctx.kind]
              ]),
              _hoisted_9
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("label", _hoisted_11, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.kind = $event)),
                  type: "radio",
                  value: "amount"
                }, null, 512), [
                  [_vModelRadio, _ctx.kind]
                ]),
                _hoisted_12
              ]),
              _hoisted_13,
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dollars = $event)),
                type: "number",
                step: "0.01",
                min: "0",
                "aria-label": "上限（ドル）",
                class: "w-28 h-9 bg-primary-100 rounded-md border border-primary-100 focus:border-primary-500 outline-none text-gray-700 px-3",
                onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.kind = 'amount'))
              }, null, 544), [
                [_vModelText, _ctx.dollars]
              ]),
              (_ctx.amountMicroUsd !== null)
                ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.yenText(_ctx.amountMicroUsd)), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("label", _hoisted_15, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.kind = $event)),
                type: "radio",
                value: "none"
              }, null, 512), [
                [_vModelRadio, _ctx.kind]
              ]),
              _hoisted_16
            ])
          ])
        ]),
        _createVNode("div", null, [
          _hoisted_17,
          _createVNode("div", _hoisted_18, [
            _createVNode("label", _hoisted_19, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.timing = $event)),
                type: "radio",
                value: "now"
              }, null, 512), [
                [_vModelRadio, _ctx.timing]
              ]),
              _hoisted_20
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode("label", _hoisted_22, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.timing = $event)),
                  type: "radio",
                  value: "at"
                }, null, 512), [
                  [_vModelRadio, _ctx.timing]
                ]),
                _hoisted_23
              ]),
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.effectiveFromLocal = $event)),
                type: "datetime-local",
                "aria-label": "適用開始の日時",
                class: "h-9 bg-primary-100 rounded-md border border-primary-100 focus:border-primary-500 outline-none text-gray-700 px-3",
                onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.timing = 'at'))
              }, null, 544), [
                [_vModelText, _ctx.effectiveFromLocal]
              ])
            ])
          ]),
          _hoisted_24
        ]),
        _createVNode(_component_m_text_area, {
          label: "理由（必須）",
          name: "llmUsageLimitReason",
          value: _ctx.reason,
          onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.reason = $event))
        }, null, 8, ["value"])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        color: "gray-400",
        "hover-color": "gray-500",
        outline: "",
        class: "mr-4",
        onClick: _ctx.close
      }, {
        default: _withCtx(() => [
          _hoisted_25
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.canSubmit,
        onClick: _ctx.confirm
      }, {
        default: _withCtx(() => [
          _hoisted_26
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}